export class ConstantsSonstige {
  static readonly FILENAME_TIERWOHLINDIKATOR: string = 'Tierwohlindikator-';
  static readonly FILENAME_TIERWOHL_BEGLEITINDIKATOREN: string =
    'Tierwohl-Begleitindikatoren-';
  static readonly FILENAME_GESAMT: string = 'Gesamt';
  static readonly FILENAME_AQUAKULTUR: string = 'Aquakultur';
  static readonly FILENAME_GEFLUEGEL: string = 'Geflügel';
  static readonly FILENAME_RIND: string = 'Rind';
  static readonly FILENAME_SCHWEIN: string = 'Schwein';
  static readonly FILENAME_SCHAF_ZIEGE: string = 'Schaf_Ziege';
  static readonly FILENAME_SOE: string = 'SÖ';
  static readonly FILENAME_TUS: string = 'TUS';
  static readonly FILENAME_ABKUERZUNG: string = 'Abkuerzungen';

  static readonly MAX_DOWNLOAD_DATENSAETZE: number = 1500;
}
